import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SliderContentGet } from '../../services';

export const fetchSliderContentGet = createAsyncThunk(
    'sliderContentGet/fetchSliderContentGet',
    async ({ id }) => {
        const response = await SliderContentGet(id)
        return response.result
    }
);

const sliderContentGetSlice = createSlice({
    name: 'sliderContentGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderContentGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderContentGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderContentGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderContentGetSlice.reducer;
